import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppSettingsViewModel } from '../models/ac-forms.models';

declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class AppInitService {

  private get appInfoApi(): string {
    return '/AppInfo';
  }

  public init() {
    return this.http.get<AppSettingsViewModel>(`${this.appInfoApi}/GetFrontendSettings`).pipe(
      map(config => {
        window.config = config;
        return config;
      })).toPromise();
  }

  constructor(private http: HttpClient) { }
}
